import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

import { isExternalParticipationHref } from '@/shared/lib/catalog-participation'

type CatalogItemLinkProps = {
  href: string
  className?: string
  children: ReactNode
}

/** catalog 卡片链接：支持本域 Router Link 与跨租户绝对 URL */
export function CatalogItemLink({ href, className, children }: CatalogItemLinkProps) {
  if (isExternalParticipationHref(href)) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    )
  }
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  )
}
